import * as React from 'react';

function SvgCloseQuote(props) {
  return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 51 40" {...props}>
    <path
      fill="#FF3E45"
      d="M39.484 0q5.209 0 8.363 3.574Q51 7.285 51 13.47q0 7.422-4.798 14.158Q41.403 34.364 31.669 40l-4.25-4.949q4.936-4.123 8.5-7.835 3.428-3.573 3.702-6.46l-.548-.412q-.96.825-3.017.824-3.153 0-5.346-2.749t-2.194-7.422q0-4.812 3.016-7.973Q34.55 0 39.484 0m-27.42 0q5.21 0 8.363 3.574 3.154 3.711 3.154 9.897 0 7.422-4.799 14.158T4.25 40L0 35.051q4.936-4.123 8.5-7.835 3.428-3.573 3.702-6.46l-.549-.412q-.96.825-3.016.824-3.153 0-5.347-2.749-2.193-2.749-2.193-7.422 0-4.812 3.016-7.973Q7.128 0 12.065 0"
    />
  </svg>)
}
export default SvgCloseQuote;
